import { z } from "zod";

import { vtGeneralSchema } from "./sections/general.js";
import { vtLocationSchema } from "./sections/location.js";
import { vtAccessSchema } from "./sections/access.js";
import { vtTerrainSchema } from "./sections/terrain.js";
import { vtExtensionSchema } from "./sections/extension.js";
import { vtUtilitiesSchema } from "./sections/utilities.js";
import { vtArtisanSchema } from "./sections/artisan.js";
import { vtClientWorksSchema } from "./sections/client-works.js";
import { vtRemarksSchema } from "./sections/remarks.js";
import { vtSignaturesSchema } from "./sections/signatures.js";
import { vtInternalSchema } from "./sections/internal.js";

/**
 * Root VT payload, lenient. Drafts allow any section to be missing.
 * Completion checks live separately (see relais-front/features/vt-visite/validation).
 */
export const VT_PAYLOAD_VERSION = 1 as const;

export const vtPayloadSchema = z
  .object({
    version: z.literal(VT_PAYLOAD_VERSION).optional(),
    general: vtGeneralSchema.optional(),
    location: vtLocationSchema.optional(),
    access: vtAccessSchema.optional(),
    terrain: vtTerrainSchema.optional(),
    extension: vtExtensionSchema.optional(),
    utilities: vtUtilitiesSchema.optional(),
    artisan: vtArtisanSchema.optional(),
    clientWorks: vtClientWorksSchema.optional(),
    remarks: vtRemarksSchema.optional(),
    signatures: vtSignaturesSchema.optional(),
    internal: vtInternalSchema.optional(),
  })
  .partial();

export type VtPayload = z.infer<typeof vtPayloadSchema>;

export const emptyVtPayload = (): VtPayload => ({
  version: VT_PAYLOAD_VERSION,
});
